import React , { useState , useEffect , createContext, useContext } from 'react';
import authenticationService from '../Services/AuthService';

const authContext = createContext();

export function ProvideAuth({children}){
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>
}

export const useAuth = () => {
    return useContext(authContext);
}

function useProvideAuth(){
    
    const isDev = process.env.NODE_ENV !== 'production';
    const [isAuthenticated,setIsAuthenticated] = useState(isDev ? true : false);
    
    const login = (email,password) => authenticationService.login(email,password)
    .then((res) => {
        setIsAuthenticated(res);
        return res;
    });

    const logout = () => authenticationService.logout()
    .then((res) => setIsAuthenticated(res));

    return {
        isAuthenticated,
        login,
        logout
    };
}
